import { Theme } from '@mui/material/styles';

export const list = (theme: Theme) => ({
    fontSize: 12,
    textAlign: 'justify',
    color: 'text.secondary',

    '& > ol': {
        paddingLeft: theme.spacing(2),

        '& > li': {
            paddingBottom: theme.spacing(2),
        },

        '& ol': {
            paddingLeft: theme.spacing(4),
        }
    },
}) as const;
